// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1cuic","footer":"ModalFilter_footer__1uOpI"};